module.exports = __webpack_public_path__ + "img/about_logo_21.c59b17c5.png";